import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const locationService = {
  fetchLocations: () => {
    return axiosInstance.get(
      "/itl_locations?$select=itl_locationid,itl_locationname,statecode&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchActiveLocations: () => {
    return axiosInstance.get(
      "/itl_locations?$select=itl_locationid,itl_locationname,statecode&$filter=statecode eq 0&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  addLocation: (obj) => {
    return axiosInstance.post("/itl_locations", obj, {
      headers: headers,
    });
  },

  updateLocation: (id, obj) => {
    return axiosInstance.patch(`/itl_locations(${id})`, obj, {
      headers: headers,
    });
  },
};

export default locationService;
